// src/components/layout/PageContainer.jsx
"use client";

const WIDTH_CLASS = {
  sm: "max-w-2xl",
  md: "max-w-3xl",
  lg: "max-w-5xl",
};

export default function PageContainer({
  as: Component = "main",
  size = "md",
  className = "",
  topPadding = true,
  bottomPadding = true,
  children,
  ...rest
}) {
  const widthClass = WIDTH_CLASS[size] || WIDTH_CLASS.md;
  const spacing = [
    topPadding ? "pt-10" : "",
    bottomPadding ? "pb-24" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const classes = ["mx-auto", widthClass, "px-4", spacing, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}
